import React, {useEffect, useState} from 'react';
import ProductItemEditorTemplate from './ProductItemEditorTemplate';
import productService from '../../services/ProductService';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';

const ProductItemEditor = () => {

    const urlParts = window.location.pathname.split('/')
    const productId = urlParts[4];
    const id = urlParts[6];

    useTitle([
        {name: 'Raktár', url: '/dashboard/storage/products'},
        {name: 'Termék', url: '/dashboard/storage/products/' + productId},
        {name: 'Termék Elem', url: '/dashboard/storage/products/' + productId + '/item/' + id}
    ])

    const [productItem, setProductItem] = useState({});
    const [message, setMessage] = useState('')
    const [waitingForServer, setWaitingForServer] = useState(false)
    const {sendAlertMessage} = useSnackbar()

    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return
        productService.findItemById(id)
            .then(response => setProductItem(response))
            .catch(() => sendAlertMessage('Termék Példány lekérése sikertelen', 'error'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const onChange = (event) => {
        const {name, value} = event.target;
        setProductItem((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const update = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        productService.updateProductItem(id, productItem)
            .then(() => {
                sendAlertMessage('Termék Példány mentésre került')
                navigate(-1)
            })
            .catch(error => setMessage(error))
            .finally(() => setWaitingForServer(false))
    };

    const onChangeSelectItem = (newValue, field) => {
        setProductItem((prev) => ({
            ...prev,
            [field]: newValue,
        }));
    };

    return (
        <ProductItemEditorTemplate
            {...{
                id,
                productItem,
                message,
                onChangeSelectItem,
                onChange,
                update,
                navigate,
                waitingForServer
            }}
        />
    );
};

export default ProductItemEditor;
